import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import UnassignedField from '@/components/global/fields/UnassignedField.jsx';

export const ServiceRequestUsersField = ({ record }) => {
    if (!record) {
        return null;
    }

    const coordinator = record.coordinator;
    const serviceman = record.serviceman;
    let coordinatorContent = <UnassignedField />;

    if (record.coordinatorId) {
        coordinatorContent = coordinator ? (
            <Typography>
                {coordinator.firstName} {coordinator.lastName}
            </Typography>
        ) : (
            <UnassignedField label='—' />
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', whiteSpace: 'nowrap' }}>
            <Box>{coordinatorContent}</Box>
            <Box>
                {record.servicemanId && serviceman && (
                    <Typography sx={{ fontSize: '11px !important' }}>
                        {serviceman.firstName} {serviceman.lastName}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

ServiceRequestUsersField.propTypes = {
    record: PropTypes.shape({
        coordinatorId: PropTypes.string,
        coordinator: PropTypes.shape({
            firstName: PropTypes.string,
            lastName: PropTypes.string,
        }),
        servicemanId: PropTypes.string,
        serviceman: PropTypes.shape({
            firstName: PropTypes.string,
            lastName: PropTypes.string,
        }),
    }),
};
